const { ACTION_TYPES } = require("./types");

export const clearAssignTemplateStatus = () => {
  return {
    type: ACTION_TYPES.ASSIGN_TEMPLATE_CLEAR,
  };
};
